import { USER_ADD_BODY_STYLE_FILTER, USER_REMOVE_BODY_STYLE_FILTER } from '../constants';

/**
 * Add body type filter
 * @returns {function(*)}
 */
export function addBodyStyleFilterAction(bodyStyle) {
  return (dispatch) => {
    dispatch({
      type: USER_ADD_BODY_STYLE_FILTER,
      bodyStyle
    });
  };
}

/**
 * Add body type filter
 * @returns {function(*)}
 */
export function removeBodyStyleFilterAction(bodyStyle) {
  return (dispatch) => {
    dispatch({
      type: USER_REMOVE_BODY_STYLE_FILTER,
      bodyStyle
    });
  };
}



/** WEBPACK FOOTER **
 ** ./src/redux/actions/bodyStyleFilter.js
 **/